export const TYPE_BRANCHES = 'branches';
export const TYPE_PROCESSING = 'processing';
export const TYPE_NBU = 'nbu';
export const TYPE_BUSINESS = 'business';
export const TYPE_APP = 'app';
